import styles from "./MissingPoster.module.css";

type MissingPosterProps = {
    text?: "?" | "!";
}

//#region [Component]
export default function MissingPoster({ text = "?" }: MissingPosterProps) {
    return <div className={styles.MissingPoster}><span>{text}</span></div>;
}
//#endregion
